<div class="form-group">
    <div class="font-weight-bold">{{ 'assigned-desk' | translate }}</div>
    <mat-form-field class="ml-2">
        <mat-select name="deskId" #deskId="ngModel" [(ngModel)]="device.deskId">
            <mat-option>{{'no-desk' | translate}}</mat-option>
            <mat-option *ngFor="let desk of desks" [value]="desk.id">{{ desk.name }} {{desk.deskNumber}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
